import { ColDef } from '@ag-grid-community/core';
import { WalletRecordMapped } from '@tassat/fred-extended-definitions';

import { obscureAccountNo } from 'Lib/stringHelpers';

const didAccountPermissionUpdate = (walletA: WalletRecordMapped, walletB: WalletRecordMapped) => {
    if (!walletA){
        return !walletB;
    } else {
        return walletA?.wallet?.AccessControl === walletB?.wallet?.AccessControl;
    }
};

export const firmWalletsColumnDefs: ColDef[] = [
    {
        field: 'wallet.AccountName',
        headerName: 'Account Name',
        sortingOrder: [ 'asc', 'desc' ],
        menuTabs: ['filterMenuTab'],
        flex: 12
    },
    {
        field: 'wallet.linkedBDAccountNumber',
        headerName: 'Linked BD Account Number',
        valueGetter: (params) => obscureAccountNo(params.data.wallet?.LinkedAccount?.Account),
        menuTabs: ['filterMenuTab'],
        flex: 12
    },
    {
        field: 'wallet.availableBalance',
        headerName: 'Available Balance',
        cellRenderer: 'formatAvailBalance',
        valueGetter: ({ data }) => (data),
        menuTabs: ['filterMenuTab'],
        flex: 10
    },
    {
        field: 'wallet.currentBalance',
        headerName: 'Current Balance',
        cellRenderer: 'formatCurrBalance',
        valueGetter: ({ data }) => (data),
        menuTabs: ['filterMenuTab'],
        flex: 10
    },
    {
        // IBN-986: Adding field name for QA automation
        // valueGetter will overwrite value anyway
        field: 'wallet.AccessControl',
        headerName: 'Access Control',
        cellRenderer: 'walletPermissionsCellRenderer',
        valueGetter: (params) => params.data.wallet?.AccessControl,
        equals: didAccountPermissionUpdate,
        menuTabs: ['filterMenuTab'],
        flex: 8
    },
    {
        field: 'wallet.primaryAccount',
        headerName: 'Primary Account',
        cellRenderer: 'isPrimaryCellRenderer',
        valueGetter: (params) => params.data.wallet?.IsPrimary,
        menuTabs: [],
        flex: 7
    },
    {
        field: 'wallet.Account',
        headerName: 'Account Address',
        cellRenderer: 'multiLineCellRenderer',
        menuTabs: ['filterMenuTab'],
        flex: 15
    },
    {
        field: 'wallet.lastActivity',
        headerName: 'Last Activity',
        valueGetter: ({ data }) => (data),
        cellRenderer: 'lastTransactionDateCellRenderer',
        minWidth: 120,
        menuTabs: ['filterMenuTab'],
        flex: 9
    },
    {
        field: 'wallet.status',
        headerName: '',
        cellRenderer: 'walletStatusCellRenderer',
        valueGetter: ({ data }) => (data),
        menuTabs: [],
        flex: 7
    },
    {
        field: 'wallet.IsClosed',
        colId: 'wallet.IsClosed',
        filter: 'agTextColumnFilter',
        headerName: 'Wallet Closed Status',
        hide: true
    }
];